"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utcToZonedTime_1 = __importDefault(require("date-fns-tz/utcToZonedTime"));
const KSA_TIMEZONE_1 = __importDefault(require("../../../constants/date/KSA_TIMEZONE"));
/**
 * Converts a JS Date to local KSA date
 * @param {Date} date
 * @returns {Date}
 */
function getKSADate(date) {
    return (0, utcToZonedTime_1.default)(date, KSA_TIMEZONE_1.default);
}
exports.default = getKSADate;
